// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e3121c10","703":"3db4bda3"}[chunkId] + ".chunk.js";
};